/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Double: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  addressId?: Maybe<Scalars['String']['output']>;
  apartment?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<AddressAttribute>>>;
  city?: Maybe<Scalars['String']['output']>;
  consumerSpecifiedAddressNormalization?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<AddressHours>;
  images?: Maybe<Array<Maybe<AddressImage>>>;
  instructions?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedAddressId?: Maybe<Scalars['String']['output']>;
  pickupInstructions?: Maybe<Scalars['String']['output']>;
  preferredLocation?: Maybe<Scalars['String']['output']>;
  preferredPickupLocation?: Maybe<Scalars['String']['output']>;
  securityCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PropertyType>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum AddressAttribute {
  GatedCommunity = 'gatedCommunity',
  HasDog = 'hasDog',
  UseCodeToAccess = 'useCodeToAccess'
}

export type AddressHours = {
  __typename?: 'AddressHours';
  dayHours?: Maybe<Array<DayHours>>;
  enabled: Scalars['Boolean']['output'];
};

export type AddressHoursInput = {
  dayHours: Array<DayHoursInput>;
  normalizedAddressId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressImage = {
  __typename?: 'AddressImage';
  addressId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  imageType: AddressImageType;
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  location?: Maybe<ImageLocationData>;
  meta?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum AddressImageType {
  PlacementPhoto = 'placementPhoto'
}

export type AddressInput = {
  existingAddress?: InputMaybe<ExistingAddressInput>;
  newAddress?: InputMaybe<NewAddressInput>;
};

export type AttachmentDataInput = {
  attachmentDataUrl: Scalars['String']['input'];
  attachmentType: AttachmentType;
};

export enum AttachmentType {
  Photo = 'photo'
}

export type CalculatedOrderInformation = {
  __typename?: 'CalculatedOrderInformation';
  isDeliveryByEvening?: Maybe<Scalars['Boolean']['output']>;
  orderDeliveryDates: Array<Scalars['String']['output']>;
  orderStatus: OrderStatus;
};

export type CalculatedPackagesInformation = {
  __typename?: 'CalculatedPackagesInformation';
  deliveredPackages: DeliveredPackages;
  notDeliveredPackages: NotDeliveredPackages;
  notPickedUpPackages: NotPickedUpPackages;
  pickedUpPackages: PickedUpPackages;
  totalPackages: Scalars['Int']['output'];
};

export type Consumer = {
  __typename?: 'Consumer';
  agreedToTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  consumerId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  latestTermsVersionAgreedTo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationPreferences?: Maybe<NotificationPreference>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  submittedAppReviewDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerMobileAppFeedback = {
  __typename?: 'ConsumerMobileAppFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  feedback: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ConsumerSubmittedFeedback = {
  __typename?: 'ConsumerSubmittedFeedback';
  clientId: Scalars['ID']['output'];
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  feedback: Scalars['AWSJSON']['output'];
  orderId: Scalars['ID']['output'];
  packageId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerSubmittedFeedbackInput = {
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
  feedback: Scalars['AWSJSON']['input'];
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};

export type ConsumerSupportCase = {
  __typename?: 'ConsumerSupportCase';
  caseCategory: ConsumerSupportCaseCategory;
  caseDetails?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['ID']['output'];
  caseStatus: ConsumerSupportCaseStatus;
  clientId?: Maybe<Scalars['ID']['output']>;
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum ConsumerSupportCaseCategory {
  DeliveryDelayed = 'deliveryDelayed',
  InstructionsNotFollowed = 'instructionsNotFollowed',
  OrderContentsIssue = 'orderContentsIssue',
  Other = 'other',
  PackageDamaged = 'packageDamaged',
  PackageMissing = 'packageMissing',
  WrongPlace = 'wrongPlace'
}

export enum ConsumerSupportCaseStatus {
  CaseClosed = 'caseClosed',
  CaseHold = 'caseHold',
  CaseNew = 'caseNew',
  CaseOpen = 'caseOpen',
  CasePending = 'casePending',
  CaseSolved = 'caseSolved'
}

export type CreateConsumerSupportCaseInput = {
  caseCategory: ConsumerSupportCaseCategory;
  caseDetails?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  requesterEmail: Scalars['String']['input'];
  requesterName: Scalars['String']['input'];
  requesterPhone: Scalars['String']['input'];
};

export type CreateConsumerSupportCaseResponse = {
  __typename?: 'CreateConsumerSupportCaseResponse';
  caseCategory: ConsumerSupportCaseCategory;
  caseDetails?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['ID']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  taskCreated?: Maybe<Scalars['Boolean']['output']>;
};

export type DayHours = {
  __typename?: 'DayHours';
  closeTime?: Maybe<Scalars['String']['output']>;
  dayOfWeek: DayOfWeek;
  isClosed: Scalars['Boolean']['output'];
  openPeriods?: Maybe<Array<DayTimePeriod>>;
  openTime?: Maybe<Scalars['String']['output']>;
};

export type DayHoursInput = {
  close?: InputMaybe<DayTimeInput>;
  open: DayTimeInput;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DayTime = {
  __typename?: 'DayTime';
  day: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type DayTimeInput = {
  day: Scalars['Int']['input'];
  time: Scalars['String']['input'];
};

export type DayTimePeriod = {
  __typename?: 'DayTimePeriod';
  close?: Maybe<DayTime>;
  open: DayTime;
};

export type DebugOverrideInput = {
  consumerId?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveredPackages = {
  __typename?: 'DeliveredPackages';
  groupedByDeliveredAtTime: Array<Maybe<GroupedByDeliveredAtTime>>;
  total: Scalars['Int']['output'];
};

export type DeliveryDate = {
  __typename?: 'DeliveryDate';
  date: Scalars['String']['output'];
  dateType: DeliveryDateType;
  hasBeenUpdated: Scalars['Boolean']['output'];
};

export enum DeliveryDateType {
  Delayed = 'Delayed',
  Estimated = 'Estimated',
  Expected = 'Expected'
}

export type DeliveryTimeWindow = {
  __typename?: 'DeliveryTimeWindow';
  endsAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startsAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type EventLog = {
  __typename?: 'EventLog';
  facility?: Maybe<Facility>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  operation: PackageEventOperations;
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ExistingAddressInput = {
  sourceAddressId: Scalars['String']['input'];
  targetAddressId: Scalars['String']['input'];
};

export type Facility = {
  __typename?: 'Facility';
  city: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GroupedByDeliveredAtTime = {
  __typename?: 'GroupedByDeliveredAtTime';
  deliveredAt: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type GroupedByPickedUpAtTime = {
  __typename?: 'GroupedByPickedUpAtTime';
  pickedUpAt: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type GroupedDeliveryDate = {
  __typename?: 'GroupedDeliveryDate';
  deliveryDate: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type GroupedDeliveryWindow = {
  __typename?: 'GroupedDeliveryWindow';
  endsAt: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type GroupedPickUpDate = {
  __typename?: 'GroupedPickUpDate';
  pickUpDate: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type GroupedPickUpWindow = {
  __typename?: 'GroupedPickUpWindow';
  endsAt: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  trackingIds: Array<Scalars['String']['output']>;
};

export type ImageLocationData = {
  __typename?: 'ImageLocationData';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type ImageLocationDataInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageUploadUrl = {
  __typename?: 'ImageUploadUrl';
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LocationInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  agreeToTermsAndConditions?: Maybe<Consumer>;
  createConsumerSubmittedFeedback?: Maybe<ConsumerSubmittedFeedback>;
  createConsumerSupportCase?: Maybe<CreateConsumerSupportCaseResponse>;
  createSupportConversationFeedback?: Maybe<SupportConversationFeedback>;
  createTermsAndConditions?: Maybe<TermsAndConditions>;
  editOrder?: Maybe<Order>;
  loginWithToken?: Maybe<Scalars['String']['output']>;
  logout: Scalars['Boolean']['output'];
  registerPushToken?: Maybe<Scalars['Boolean']['output']>;
  removeAddressImage?: Maybe<AddressImage>;
  revokePushToken?: Maybe<Scalars['Boolean']['output']>;
  submitConsumerMobileAppFeedback?: Maybe<ConsumerMobileAppFeedback>;
  submittedAppReviewDate?: Maybe<Consumer>;
  updateAddress?: Maybe<Address>;
  updateAddressHours?: Maybe<AddressHours>;
  updateClientAddressInstructions?: Maybe<Address>;
  updateClientAddressInstructionsForOrder?: Maybe<Address>;
  updateNormalizedAddress?: Maybe<Address>;
  upsertAddressImage?: Maybe<AddressImage>;
  upsertNotificationPreference?: Maybe<NotificationPreference>;
};


export type MutationCreateConsumerSubmittedFeedbackArgs = {
  feedbackInput: ConsumerSubmittedFeedbackInput;
};


export type MutationCreateConsumerSupportCaseArgs = {
  caseInput: CreateConsumerSupportCaseInput;
};


export type MutationCreateSupportConversationFeedbackArgs = {
  feedbackInput: SupportConversationFeedbackInput;
};


export type MutationCreateTermsAndConditionsArgs = {
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditOrderArgs = {
  addressInput?: InputMaybe<NewAddressInput>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRegisterPushTokenArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRemoveAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  imageType: AddressImageType;
};


export type MutationRevokePushTokenArgs = {
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSubmitConsumerMobileAppFeedbackArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAddressArgs = {
  addressId: Scalars['ID']['input'];
  addressInput: UpdateAddressInput;
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
  normalizedAddressId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAddressHoursArgs = {
  addressHoursInput: AddressHoursInput;
};


export type MutationUpdateClientAddressInstructionsArgs = {
  addressId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
  updateInstructionsInput: UpdateInstructionsInput;
};


export type MutationUpdateClientAddressInstructionsForOrderArgs = {
  orderId: Scalars['ID']['input'];
  updateInstructionsInput: UpdateInstructionsInput;
};


export type MutationUpdateNormalizedAddressArgs = {
  debug?: InputMaybe<DebugOverrideInput>;
  normalizedAddressId: Scalars['String']['input'];
  normalizedAddressInput: NewAddressInput;
  targetOrderId: Scalars['String']['input'];
};


export type MutationUpsertAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  addressImageInput: UpsertAddressImageInput;
  imageType: AddressImageType;
};


export type MutationUpsertNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
  notificationPreferenceInput: UpdateNotificationPreferenceInput;
};

export type NewAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<AddressAttribute>>>;
  city: Scalars['String']['input'];
  consumerSpecifiedAddressNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  name: Scalars['String']['input'];
  pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  preferredLocation?: InputMaybe<Scalars['String']['input']>;
  preferredPickupLocation?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  type?: InputMaybe<PropertyType>;
  userServedGeocodeCorrectionFlag?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};

export type NotDeliveredPackages = {
  __typename?: 'NotDeliveredPackages';
  groupedByDeliveryDate: Array<Maybe<GroupedDeliveryDate>>;
  groupedByDeliveryWindow: Array<Maybe<GroupedDeliveryWindow>>;
  groupedByEveningPackages: Array<Maybe<Scalars['String']['output']>>;
  groupedByMissingDeliveryDate: Array<Maybe<Scalars['String']['output']>>;
  total: Scalars['Int']['output'];
};

export type NotPickedUpPackages = {
  __typename?: 'NotPickedUpPackages';
  groupedByEveningPackages: Array<Maybe<Scalars['String']['output']>>;
  groupedByMissingPickUpDate: Array<Maybe<Scalars['String']['output']>>;
  groupedByPickUpDate: Array<Maybe<GroupedPickUpDate>>;
  groupedByPickUpWindow: Array<Maybe<GroupedPickUpWindow>>;
  total: Scalars['Int']['output'];
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channel?: Maybe<Array<Maybe<PreferenceChannel>>>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  invalidSmsDestination?: Maybe<Scalars['Boolean']['output']>;
  optedOutViaCarrier?: Maybe<Scalars['Boolean']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  address: Address;
  addressCorrectionAllowed?: Maybe<Scalars['Boolean']['output']>;
  addressId?: Maybe<Scalars['String']['output']>;
  alert?: Maybe<OrderAlert>;
  authedUserOwnsOrder?: Maybe<Scalars['Boolean']['output']>;
  calculatedOrderInformation: CalculatedOrderInformation;
  calculatedPackagesInformation: CalculatedPackagesInformation;
  clientDisplayName: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  consumerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use deliveryDateInfo instead */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryDateInfo?: Maybe<DeliveryDate>;
  deliveryTimeWindow?: Maybe<DeliveryTimeWindow>;
  facilityId?: Maybe<Scalars['String']['output']>;
  hasApartment?: Maybe<Scalars['Boolean']['output']>;
  hasCode?: Maybe<Scalars['Boolean']['output']>;
  hasInstructions?: Maybe<Scalars['Boolean']['output']>;
  instructionEditsAllowed?: Maybe<Scalars['Boolean']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isEditable: Scalars['Boolean']['output'];
  isOrderReroutable: Scalars['Boolean']['output'];
  isOrderReroutableByConsumer: Scalars['Boolean']['output'];
  isPastConsumerRerouteCutoff: Scalars['Boolean']['output'];
  isPastRerouteCutoff: Scalars['Boolean']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  originalAddress?: Maybe<Address>;
  packages: Array<Package>;
  reroutableZipCodes: Array<Scalars['String']['output']>;
  rerouteBlockedByClient?: Maybe<Scalars['Boolean']['output']>;
  serviceType: OrderServiceType;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type OrderAlert = {
  __typename?: 'OrderAlert';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum OrderServiceType {
  Delivery = 'delivery',
  Pickup = 'pickup'
}

export enum OrderStatus {
  Cancelled = 'cancelled',
  Created = 'created',
  Delivered = 'delivered',
  Discarded = 'discarded',
  DroppedOffAtVeho = 'droppedOffAtVeho',
  IssueWithOrder = 'issueWithOrder',
  Misdelivered = 'misdelivered',
  NoDeliveryDate = 'noDeliveryDate',
  NotFound = 'notFound',
  NotReceivedFromClient = 'notReceivedFromClient',
  OutForPickup = 'outForPickup',
  Pending = 'pending',
  PickedUpFromClient = 'pickedUpFromClient',
  PickedUpFromConsumer = 'pickedUpFromConsumer',
  PickedUpFromVeho = 'pickedUpFromVeho',
  PickupDroppedOffAtVeho = 'pickupDroppedOffAtVeho',
  PickupFailed = 'pickupFailed',
  PickupSkipped = 'pickupSkipped',
  PickupTransferredToExternalCarrier = 'pickupTransferredToExternalCarrier',
  Returned = 'returned',
  ReturnedToClient = 'returnedToClient',
  ReturnedToVeho = 'returnedToVeho',
  SeeMore = 'seeMore'
}

export enum OrderStatusType {
  IssueWithOrder = 'issueWithOrder',
  SeeMore = 'seeMore'
}

export type Package = {
  __typename?: 'Package';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  consumerId?: Maybe<Scalars['String']['output']>;
  consumerSupportCase?: Maybe<ConsumerSupportCase>;
  deliveryTimeWindow?: Maybe<DeliveryTimeWindow>;
  eventLog: Array<EventLog>;
  isPastConsumerRerouteCutoff: Scalars['Boolean']['output'];
  isPastRerouteCutoff: Scalars['Boolean']['output'];
  packageId: Scalars['ID']['output'];
  pin?: Maybe<Scalars['String']['output']>;
  requiresSignatureByPin?: Maybe<Scalars['Boolean']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  stopId?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackingId: Scalars['String']['output'];
};

export enum PackageEventOperations {
  PackageArrivedAtFacility = 'PackageArrivedAtFacility',
  PackageDelayed = 'PackageDelayed',
  PackageDepartedFromFacility = 'PackageDepartedFromFacility',
  PackageHadDeliveryIssue = 'PackageHadDeliveryIssue',
  PackageLoadedOntoFirstMileTransit = 'PackageLoadedOntoFirstMileTransit',
  Cancelled = 'cancelled',
  Created = 'created',
  Delivered = 'delivered',
  Discarded = 'discarded',
  DroppedOffAtVeho = 'droppedOffAtVeho',
  HadDeliveryIssue = 'hadDeliveryIssue',
  Misdelivered = 'misdelivered',
  NotFound = 'notFound',
  NotReceivedFromClient = 'notReceivedFromClient',
  OutForPickup = 'outForPickup',
  Pending = 'pending',
  PickedUpFromClient = 'pickedUpFromClient',
  PickedUpFromConsumer = 'pickedUpFromConsumer',
  PickedUpFromVeho = 'pickedUpFromVeho',
  PickupDroppedOffAtVeho = 'pickupDroppedOffAtVeho',
  PickupFailed = 'pickupFailed',
  PickupSkipped = 'pickupSkipped',
  PickupTransferredToExternalCarrier = 'pickupTransferredToExternalCarrier',
  Returned = 'returned',
  ReturnedToClient = 'returnedToClient',
  ReturnedToVeho = 'returnedToVeho',
  WrongFacilityByClient = 'wrongFacilityByClient',
  WrongFacilityByVeho = 'wrongFacilityByVeho'
}

export enum PackageHadDeliveryIssueSubType {
  AppIssues = 'AppIssues',
  BuildingDoorCode = 'BuildingDoorCode',
  BusinessOffice = 'BusinessOffice',
  BusinessStoreFront = 'BusinessStoreFront',
  DarkOrUnlitArea = 'DarkOrUnlitArea',
  FrontGate = 'FrontGate',
  LeasingOffice = 'LeasingOffice',
  Mailroom = 'Mailroom',
  PetOnSite = 'PetOnSite',
  RouteStartedLate = 'RouteStartedLate',
  RouteTookLongerThanEstimated = 'RouteTookLongerThanEstimated',
  SchoolCampus = 'SchoolCampus',
  WeatherRelated = 'WeatherRelated'
}

export enum PackageHadDeliveryIssueType {
  AccessIssues = 'AccessIssues',
  ClosedLocation = 'ClosedLocation',
  CustomerRefused = 'CustomerRefused',
  DamagedPackage = 'DamagedPackage',
  MilitaryAddress = 'MilitaryAddress',
  Other = 'Other',
  RanOutOfTime = 'RanOutOfTime',
  UnsafeConditions = 'UnsafeConditions',
  WrongLocation = 'WrongLocation'
}

export type PickedUpPackages = {
  __typename?: 'PickedUpPackages';
  groupedByPickedUpAtTime: Array<Maybe<GroupedByPickedUpAtTime>>;
  total: Scalars['Int']['output'];
};

export enum PreferenceChannel {
  Push = 'push',
  Sms = 'sms'
}

export type ProofOfServicePhotoUrl = {
  __typename?: 'ProofOfServicePhotoUrl';
  addressPhotoUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  packageId: Scalars['ID']['output'];
  unitPhotoUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PropertyType {
  Apartment = 'APARTMENT',
  Business = 'BUSINESS',
  House = 'HOUSE',
  Other = 'OTHER'
}

export type Query = {
  __typename?: 'Query';
  consumerHadRecentSupportInteraction?: Maybe<Scalars['Boolean']['output']>;
  getAddressFromGeocode?: Maybe<Address>;
  getConsumer?: Maybe<Consumer>;
  getConsumerAddressImageUploadUrl?: Maybe<ImageUploadUrl>;
  getConsumerOrders?: Maybe<Array<Maybe<Order>>>;
  getConsumerSubmittedFeedbackByConsumerId?: Maybe<Array<Maybe<ConsumerSubmittedFeedback>>>;
  getConsumerSubmittedFeedbackByOrderId?: Maybe<ConsumerSubmittedFeedback>;
  getConsumerSubmittedFeedbackByPackageId?: Maybe<Array<Maybe<ConsumerSubmittedFeedback>>>;
  getImageUrl?: Maybe<Scalars['String']['output']>;
  getNotificationPreference?: Maybe<NotificationPreference>;
  getOrderByTrackingId?: Maybe<Order>;
  getOrderByTrackingIdCWA?: Maybe<Order>;
  getOrdersByTrackingIds?: Maybe<Array<Maybe<Order>>>;
  getProofOfServicePhotoUrls: Array<ProofOfServicePhotoUrl>;
  getSupportConversationFeedback?: Maybe<SupportConversationFeedback>;
  isOrderAssociatedWithPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryGetAddressFromGeocodeArgs = {
  consumerId?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryGetConsumerAddressImageUploadUrlArgs = {
  addressId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  imageType: AddressImageType;
};


export type QueryGetConsumerOrdersArgs = {
  includeConsumerSupportCases?: InputMaybe<Scalars['Boolean']['input']>;
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetConsumerSubmittedFeedbackByConsumerIdArgs = {
  consumerId: Scalars['ID']['input'];
  packageId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetConsumerSubmittedFeedbackByOrderIdArgs = {
  consumerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type QueryGetConsumerSubmittedFeedbackByPackageIdArgs = {
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type QueryGetImageUrlArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetOrderByTrackingIdArgs = {
  includeConsumerSupportCases?: InputMaybe<Scalars['Boolean']['input']>;
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};


export type QueryGetOrderByTrackingIdCwaArgs = {
  includeConsumerSupportCases?: InputMaybe<Scalars['Boolean']['input']>;
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId: Scalars['String']['input'];
};


export type QueryGetOrdersByTrackingIdsArgs = {
  includeConsumerSupportCases?: InputMaybe<Scalars['Boolean']['input']>;
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
  trackingIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetProofOfServicePhotoUrlsArgs = {
  packageIds: Array<Scalars['ID']['input']>;
};


export type QueryGetSupportConversationFeedbackArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryIsOrderAssociatedWithPhoneNumberArgs = {
  orderId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SupportConversationFeedback = {
  __typename?: 'SupportConversationFeedback';
  consumerId?: Maybe<Scalars['ID']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  feedback?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SupportConversationFeedbackInput = {
  conversationId: Scalars['ID']['input'];
  feedback: Scalars['AWSJSON']['input'];
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  createdAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type UpdateAddressInput = {
  consumerSpecifiedAddressNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PropertyType>;
};

export type UpdateInstructionsInput = {
  attributes?: InputMaybe<Array<InputMaybe<AddressAttribute>>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  preferredLocation?: InputMaybe<Scalars['String']['input']>;
  preferredPickupLocation?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PropertyType>;
};

export type UpdateNotificationPreferenceInput = {
  channel: Array<InputMaybe<PreferenceChannel>>;
  consumerId: Scalars['String']['input'];
  invalidSmsDestination: Scalars['Boolean']['input'];
  optedOutViaCarrier: Scalars['Boolean']['input'];
};

export type UpsertAddressImageInput = {
  key: Scalars['String']['input'];
  location?: InputMaybe<ImageLocationDataInput>;
  meta?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AddressFieldsFragment = { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null };

export type AgreeToTermsAndConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type AgreeToTermsAndConditionsMutation = { __typename?: 'Mutation', consumer?: { __typename?: 'Consumer', consumerId: string, email?: string | null, name?: string | null, phoneNumber?: string | null, agreedToTermsAndConditions?: boolean | null, latestTermsVersionAgreedTo?: string | null, submittedAppReviewDate?: any | null, notificationPreferences?: { __typename?: 'NotificationPreference', channel?: Array<PreferenceChannel | null> | null, optedOutViaCarrier?: boolean | null, invalidSmsDestination?: boolean | null } | null } | null };

export type ConsumerHadRecentSupportInteractionQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerHadRecentSupportInteractionQuery = { __typename?: 'Query', consumerHadRecentSupportInteraction?: boolean | null };

export type CreateConsumerSubmittedFeedbackMutationVariables = Exact<{
  feedbackInput: ConsumerSubmittedFeedbackInput;
}>;


export type CreateConsumerSubmittedFeedbackMutation = { __typename?: 'Mutation', createConsumerSubmittedFeedback?: { __typename?: 'ConsumerSubmittedFeedback', consumerId: string, orderId: string, packageId: string, clientId: string, feedback: any, createdAt?: any | null, updatedAt?: any | null } | null };

export type CreateConsumerSupportCaseMutationVariables = Exact<{
  caseInput: CreateConsumerSupportCaseInput;
}>;


export type CreateConsumerSupportCaseMutation = { __typename?: 'Mutation', createConsumerSupportCase?: { __typename?: 'CreateConsumerSupportCaseResponse', caseId: string, caseCategory: ConsumerSupportCaseCategory, caseDetails?: string | null, clientId?: string | null, orderId?: string | null, packageId?: string | null, taskCreated?: boolean | null } | null };

export type EditOrderMutationVariables = Exact<{
  orderId?: InputMaybe<Scalars['String']['input']>;
  addressInput?: InputMaybe<NewAddressInput>;
}>;


export type EditOrderMutation = { __typename?: 'Mutation', editOrder?: { __typename?: 'Order', authedUserOwnsOrder?: boolean | null, clientId?: string | null, clientName: string, clientDisplayName: string, merchantName?: string | null, consumerId?: string | null, deliveryDate?: string | null, facilityId?: string | null, instructions?: string | null, isEditable: boolean, isOrderReroutableByConsumer: boolean, isPastConsumerRerouteCutoff: boolean, orderId: string, reroutableZipCodes: Array<string>, rerouteBlockedByClient?: boolean | null, serviceType: OrderServiceType, timeZone?: string | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderStatus: OrderStatus, orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, pickedUpPackages: { __typename?: 'PickedUpPackages', total: number, groupedByPickedUpAtTime: Array<{ __typename?: 'GroupedByPickedUpAtTime', pickedUpAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingPickUpDate: Array<string | null>, total: number, groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', startsAt?: any | null, endsAt?: any | null } | null, packages: Array<{ __typename?: 'Package', packageId: string, trackingId: string, scheduledServiceDate?: any | null, timeZone?: string | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, meta?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }> }> } | null };

export type GetAddressFromGeocodeQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  consumerId: Scalars['String']['input'];
}>;


export type GetAddressFromGeocodeQuery = { __typename?: 'Query', getAddressFromGeocode?: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null } | null };

export type GetConsumerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsumerQuery = { __typename?: 'Query', consumer?: { __typename?: 'Consumer', consumerId: string, email?: string | null, name?: string | null, phoneNumber?: string | null, agreedToTermsAndConditions?: boolean | null, latestTermsVersionAgreedTo?: string | null, submittedAppReviewDate?: any | null, notificationPreferences?: { __typename?: 'NotificationPreference', channel?: Array<PreferenceChannel | null> | null, optedOutViaCarrier?: boolean | null, invalidSmsDestination?: boolean | null } | null } | null };

export type GetConsumerAddressImageUploadUrlQueryVariables = Exact<{
  addressId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  imageType: AddressImageType;
}>;


export type GetConsumerAddressImageUploadUrlQuery = { __typename?: 'Query', getConsumerAddressImageUploadUrl?: { __typename?: 'ImageUploadUrl', imageUrl?: string | null, key: string, uploadUrl: string } | null };

export type GetConsumerOrdersQueryVariables = Exact<{
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConsumerOrdersQuery = { __typename?: 'Query', orders?: Array<{ __typename?: 'Order', authedUserOwnsOrder?: boolean | null, clientId?: string | null, clientName: string, clientDisplayName: string, merchantName?: string | null, consumerId?: string | null, deliveryDate?: string | null, facilityId?: string | null, instructions?: string | null, isEditable: boolean, isOrderReroutableByConsumer: boolean, isPastConsumerRerouteCutoff: boolean, orderId: string, reroutableZipCodes: Array<string>, rerouteBlockedByClient?: boolean | null, serviceType: OrderServiceType, timeZone?: string | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderStatus: OrderStatus, orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, pickedUpPackages: { __typename?: 'PickedUpPackages', total: number, groupedByPickedUpAtTime: Array<{ __typename?: 'GroupedByPickedUpAtTime', pickedUpAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingPickUpDate: Array<string | null>, total: number, groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', startsAt?: any | null, endsAt?: any | null } | null, packages: Array<{ __typename?: 'Package', packageId: string, trackingId: string, scheduledServiceDate?: any | null, timeZone?: string | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, meta?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }> }> } | null> | null };

export type GetNotificationPreferenceQueryVariables = Exact<{
  consumerId: Scalars['ID']['input'];
}>;


export type GetNotificationPreferenceQuery = { __typename?: 'Query', notificationPreference?: { __typename?: 'NotificationPreference', channel?: Array<PreferenceChannel | null> | null } | null };

export type GetOrderByTrackingIdQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrderByTrackingIdQuery = { __typename?: 'Query', order?: { __typename?: 'Order', authedUserOwnsOrder?: boolean | null, clientId?: string | null, clientName: string, clientDisplayName: string, merchantName?: string | null, consumerId?: string | null, deliveryDate?: string | null, facilityId?: string | null, instructions?: string | null, isEditable: boolean, isOrderReroutableByConsumer: boolean, isPastConsumerRerouteCutoff: boolean, orderId: string, reroutableZipCodes: Array<string>, rerouteBlockedByClient?: boolean | null, serviceType: OrderServiceType, timeZone?: string | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderStatus: OrderStatus, orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, pickedUpPackages: { __typename?: 'PickedUpPackages', total: number, groupedByPickedUpAtTime: Array<{ __typename?: 'GroupedByPickedUpAtTime', pickedUpAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingPickUpDate: Array<string | null>, total: number, groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', startsAt?: any | null, endsAt?: any | null } | null, packages: Array<{ __typename?: 'Package', packageId: string, trackingId: string, scheduledServiceDate?: any | null, timeZone?: string | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, meta?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }> }> } | null };

export type GetOrdersByTrackingIdsQueryVariables = Exact<{
  trackingIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  includePickups?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrdersByTrackingIdsQuery = { __typename?: 'Query', orders?: Array<{ __typename?: 'Order', authedUserOwnsOrder?: boolean | null, clientId?: string | null, clientName: string, clientDisplayName: string, merchantName?: string | null, consumerId?: string | null, deliveryDate?: string | null, facilityId?: string | null, instructions?: string | null, isEditable: boolean, isOrderReroutableByConsumer: boolean, isPastConsumerRerouteCutoff: boolean, orderId: string, reroutableZipCodes: Array<string>, rerouteBlockedByClient?: boolean | null, serviceType: OrderServiceType, timeZone?: string | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderStatus: OrderStatus, orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, pickedUpPackages: { __typename?: 'PickedUpPackages', total: number, groupedByPickedUpAtTime: Array<{ __typename?: 'GroupedByPickedUpAtTime', pickedUpAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingPickUpDate: Array<string | null>, total: number, groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', startsAt?: any | null, endsAt?: any | null } | null, packages: Array<{ __typename?: 'Package', packageId: string, trackingId: string, scheduledServiceDate?: any | null, timeZone?: string | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, meta?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }> }> } | null> | null };

export type GetProofOfServiceUrlsQueryVariables = Exact<{
  packageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetProofOfServiceUrlsQuery = { __typename?: 'Query', proofOfServicePhotoUrls: Array<{ __typename?: 'ProofOfServicePhotoUrl', packageId: string, url?: string | null, addressPhotoUrl?: string | null, unitPhotoUrl?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null }> };

export type LoginWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithTokenMutation = { __typename?: 'Mutation', loginWithToken?: string | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type OrderFieldsCmaFragment = { __typename?: 'Order', authedUserOwnsOrder?: boolean | null, clientId?: string | null, clientName: string, clientDisplayName: string, merchantName?: string | null, consumerId?: string | null, deliveryDate?: string | null, facilityId?: string | null, instructions?: string | null, isEditable: boolean, isOrderReroutableByConsumer: boolean, isPastConsumerRerouteCutoff: boolean, orderId: string, reroutableZipCodes: Array<string>, rerouteBlockedByClient?: boolean | null, serviceType: OrderServiceType, timeZone?: string | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderStatus: OrderStatus, orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, pickedUpPackages: { __typename?: 'PickedUpPackages', total: number, groupedByPickedUpAtTime: Array<{ __typename?: 'GroupedByPickedUpAtTime', pickedUpAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingPickUpDate: Array<string | null>, total: number, groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', startsAt?: any | null, endsAt?: any | null } | null, packages: Array<{ __typename?: 'Package', packageId: string, trackingId: string, scheduledServiceDate?: any | null, timeZone?: string | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, meta?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }> }> };

export type RegisterPushTokenMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}>;


export type RegisterPushTokenMutation = { __typename?: 'Mutation', registerPushToken?: boolean | null };

export type RemoveAddressImageMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  imageType: AddressImageType;
}>;


export type RemoveAddressImageMutation = { __typename?: 'Mutation', removeAddressImage?: { __typename?: 'AddressImage', addressId: string, imageType: AddressImageType, createdAt?: any | null, key: string, updatedAt?: any | null, meta?: string | null, tags?: Array<string | null> | null } | null };

export type RevokePushTokenMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}>;


export type RevokePushTokenMutation = { __typename?: 'Mutation', revokePushToken?: boolean | null };

export type SubmitConsumerMobileAppFeedbackMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type SubmitConsumerMobileAppFeedbackMutation = { __typename?: 'Mutation', submitConsumerMobileAppFeedback?: { __typename?: 'ConsumerMobileAppFeedback', messageId?: string | null, customerId: string, feedback: string, deviceId?: string | null } | null };

export type SubmittedAppReviewDateMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmittedAppReviewDateMutation = { __typename?: 'Mutation', consumer?: { __typename?: 'Consumer', consumerId: string, submittedAppReviewDate?: any | null } | null };

export type UpdateAddressMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  addressInput: UpdateAddressInput;
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress?: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null } | null };

export type UpdateAddressHoursMutationVariables = Exact<{
  addressHoursInput: AddressHoursInput;
}>;


export type UpdateAddressHoursMutation = { __typename?: 'Mutation', updateAddressHours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean, openPeriods?: Array<{ __typename?: 'DayTimePeriod', open: { __typename?: 'DayTime', day: number, time: string }, close?: { __typename?: 'DayTime', day: number, time: string } | null }> | null }> | null } | null };

export type UpdateClientAddressInstructionsMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  addressId: Scalars['ID']['input'];
  updateInstructionsInput: UpdateInstructionsInput;
}>;


export type UpdateClientAddressInstructionsMutation = { __typename?: 'Mutation', updateClientAddressInstructions?: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null } | null };

export type UpdateClientAddressInstructionsForOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  updateInstructionsInput: UpdateInstructionsInput;
}>;


export type UpdateClientAddressInstructionsForOrderMutation = { __typename?: 'Mutation', updateClientAddressInstructionsForOrder?: { __typename?: 'Address', instructions?: string | null, preferredLocation?: string | null, pickupInstructions?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, attributes?: Array<AddressAttribute | null> | null } | null };

export type UpdateNormalizedAddressMutationVariables = Exact<{
  normalizedAddressId: Scalars['String']['input'];
  normalizedAddressInput: NewAddressInput;
  targetOrderId: Scalars['String']['input'];
}>;


export type UpdateNormalizedAddressMutation = { __typename?: 'Mutation', updateNormalizedAddress?: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null } | null };

export type UpsertAddressImageMutationVariables = Exact<{
  addressId: Scalars['ID']['input'];
  addressImageInput: UpsertAddressImageInput;
  imageType: AddressImageType;
}>;


export type UpsertAddressImageMutation = { __typename?: 'Mutation', upsertAddressImage?: { __typename?: 'AddressImage', addressId: string, imageType: AddressImageType, createdAt?: any | null, key: string, updatedAt?: any | null, meta?: string | null, tags?: Array<string | null> | null } | null };

export type UpsertNotificationPreferenceMutationVariables = Exact<{
  consumerId: Scalars['ID']['input'];
  notificationPreferenceInput: UpdateNotificationPreferenceInput;
}>;


export type UpsertNotificationPreferenceMutation = { __typename?: 'Mutation', upsertNotificationPreference?: { __typename?: 'NotificationPreference', channel?: Array<PreferenceChannel | null> | null } | null };

export type VerifyPhoneRelatedToOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type VerifyPhoneRelatedToOrderQuery = { __typename?: 'Query', isOrderAssociatedWithPhoneNumber?: boolean | null };

export type ConsumerFieldsFragment = { __typename?: 'Consumer', consumerId: string, email?: string | null, name?: string | null, phoneNumber?: string | null, agreedToTermsAndConditions?: boolean | null, latestTermsVersionAgreedTo?: string | null, submittedAppReviewDate?: any | null, notificationPreferences?: { __typename?: 'NotificationPreference', channel?: Array<PreferenceChannel | null> | null, optedOutViaCarrier?: boolean | null, invalidSmsDestination?: boolean | null } | null };

export type AgreeToTermsAndConditionsCwaMutationVariables = Exact<{ [key: string]: never; }>;


export type AgreeToTermsAndConditionsCwaMutation = { __typename?: 'Mutation', agreeToTermsAndConditions?: { __typename?: 'Consumer', agreedToTermsAndConditions?: boolean | null } | null };

export type CreateSupportConversationFeedbackMutationVariables = Exact<{
  feedbackInput: SupportConversationFeedbackInput;
}>;


export type CreateSupportConversationFeedbackMutation = { __typename?: 'Mutation', createSupportConversationFeedback?: { __typename?: 'SupportConversationFeedback', conversationId?: string | null, feedback?: any | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type EditOrderCwaMutationVariables = Exact<{
  addressInput?: InputMaybe<NewAddressInput>;
  orderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditOrderCwaMutation = { __typename?: 'Mutation', editOrder?: { __typename?: 'Order', addressId?: string | null, addressCorrectionAllowed?: boolean | null, authedUserOwnsOrder?: boolean | null, clientName: string, clientDisplayName: string, clientId?: string | null, consumerId?: string | null, deliveryDate?: string | null, orderId: string, timeZone?: string | null, serviceType: OrderServiceType, reroutableZipCodes: Array<string>, instructionEditsAllowed?: boolean | null, hasInstructions?: boolean | null, hasCode?: boolean | null, hasApartment?: boolean | null, isOrderReroutable: boolean, isOrderReroutableByConsumer: boolean, rerouteBlockedByClient?: boolean | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, originalAddress?: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, packages: Array<{ __typename?: 'Package', requiresSignatureByPin?: boolean | null, pin?: string | null, packageId: string, trackingId: string, timeZone?: string | null, scheduledServiceDate?: any | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }>, consumerSupportCase?: { __typename?: 'ConsumerSupportCase', caseId: string, caseCategory: ConsumerSupportCaseCategory, caseDetails?: string | null, caseStatus: ConsumerSupportCaseStatus } | null }> } | null };

export type GetConsumerCwaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConsumerCwaQuery = { __typename?: 'Query', getConsumer?: { __typename?: 'Consumer', agreedToTermsAndConditions?: boolean | null, latestTermsVersionAgreedTo?: string | null } | null };

export type GetOrderByTrackingIdCwaQueryVariables = Exact<{
  trackingId: Scalars['String']['input'];
  includeConsumerSupportCases: Scalars['Boolean']['input'];
}>;


export type GetOrderByTrackingIdCwaQuery = { __typename?: 'Query', order?: { __typename?: 'Order', addressId?: string | null, addressCorrectionAllowed?: boolean | null, authedUserOwnsOrder?: boolean | null, clientName: string, clientDisplayName: string, clientId?: string | null, consumerId?: string | null, deliveryDate?: string | null, orderId: string, timeZone?: string | null, serviceType: OrderServiceType, reroutableZipCodes: Array<string>, instructionEditsAllowed?: boolean | null, hasInstructions?: boolean | null, hasCode?: boolean | null, hasApartment?: boolean | null, isOrderReroutable: boolean, isOrderReroutableByConsumer: boolean, rerouteBlockedByClient?: boolean | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, originalAddress?: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, packages: Array<{ __typename?: 'Package', requiresSignatureByPin?: boolean | null, pin?: string | null, packageId: string, trackingId: string, timeZone?: string | null, scheduledServiceDate?: any | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }>, consumerSupportCase?: { __typename?: 'ConsumerSupportCase', caseId: string, caseCategory: ConsumerSupportCaseCategory, caseDetails?: string | null, caseStatus: ConsumerSupportCaseStatus } | null }> } | null };

export type GetSupportConversationFeedbackQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type GetSupportConversationFeedbackQuery = { __typename?: 'Query', getSupportConversationFeedback?: { __typename?: 'SupportConversationFeedback', conversationId?: string | null, createdAt?: any | null } | null };

export type OrderFieldsCwaFragment = { __typename?: 'Order', addressId?: string | null, addressCorrectionAllowed?: boolean | null, authedUserOwnsOrder?: boolean | null, clientName: string, clientDisplayName: string, clientId?: string | null, consumerId?: string | null, deliveryDate?: string | null, orderId: string, timeZone?: string | null, serviceType: OrderServiceType, reroutableZipCodes: Array<string>, instructionEditsAllowed?: boolean | null, hasInstructions?: boolean | null, hasCode?: boolean | null, hasApartment?: boolean | null, isOrderReroutable: boolean, isOrderReroutableByConsumer: boolean, rerouteBlockedByClient?: boolean | null, alert?: { __typename?: 'OrderAlert', title: string, body: string } | null, address: { __typename?: 'Address', addressId?: string | null, normalizedAddressId?: string | null, consumerSpecifiedAddressNormalization?: boolean | null, type?: PropertyType | null, name?: string | null, street?: string | null, apartment?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, attributes?: Array<AddressAttribute | null> | null, instructions?: string | null, pickupInstructions?: string | null, preferredLocation?: string | null, preferredPickupLocation?: string | null, securityCode?: string | null, location?: { __typename?: 'Location', lat: number, lng: number } | null, images?: Array<{ __typename?: 'AddressImage', addressId: string, createdAt?: any | null, imageType: AddressImageType, key: string, meta?: string | null, tags?: Array<string | null> | null, updatedAt?: any | null, imageUrl?: string | null, location?: { __typename?: 'ImageLocationData', lat?: number | null, lng?: number | null } | null } | null> | null, hours?: { __typename?: 'AddressHours', enabled: boolean, dayHours?: Array<{ __typename?: 'DayHours', dayOfWeek: DayOfWeek, openTime?: string | null, closeTime?: string | null, isClosed: boolean }> | null } | null }, originalAddress?: { __typename?: 'Address', street?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, calculatedOrderInformation: { __typename?: 'CalculatedOrderInformation', orderDeliveryDates: Array<string>, isDeliveryByEvening?: boolean | null }, calculatedPackagesInformation: { __typename?: 'CalculatedPackagesInformation', totalPackages: number, deliveredPackages: { __typename?: 'DeliveredPackages', total: number, groupedByDeliveredAtTime: Array<{ __typename?: 'GroupedByDeliveredAtTime', deliveredAt: string, trackingIds: Array<string> } | null> }, notDeliveredPackages: { __typename?: 'NotDeliveredPackages', groupedByEveningPackages: Array<string | null>, groupedByMissingDeliveryDate: Array<string | null>, total: number, groupedByDeliveryDate: Array<{ __typename?: 'GroupedDeliveryDate', deliveryDate: string, trackingIds: Array<string> } | null>, groupedByDeliveryWindow: Array<{ __typename?: 'GroupedDeliveryWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> }, notPickedUpPackages: { __typename?: 'NotPickedUpPackages', groupedByPickUpDate: Array<{ __typename?: 'GroupedPickUpDate', pickUpDate: string, trackingIds: Array<string> } | null>, groupedByPickUpWindow: Array<{ __typename?: 'GroupedPickUpWindow', endsAt: string, startsAt: string, trackingIds: Array<string> } | null> } }, deliveryDateInfo?: { __typename?: 'DeliveryDate', date: string, dateType: DeliveryDateType, hasBeenUpdated: boolean } | null, packages: Array<{ __typename?: 'Package', requiresSignatureByPin?: boolean | null, pin?: string | null, packageId: string, trackingId: string, timeZone?: string | null, scheduledServiceDate?: any | null, deliveryTimeWindow?: { __typename?: 'DeliveryTimeWindow', endsAt?: any | null, startsAt?: any | null } | null, eventLog: Array<{ __typename?: 'EventLog', operation: PackageEventOperations, timestamp?: any | null, message?: string | null, facility?: { __typename?: 'Facility', facilityId: string, city: string, state: string } | null }>, consumerSupportCase?: { __typename?: 'ConsumerSupportCase', caseId: string, caseCategory: ConsumerSupportCaseCategory, caseDetails?: string | null, caseStatus: ConsumerSupportCaseStatus } | null }> };
